import moment from 'moment';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

TimeAgo.addDefaultLocale(en);

export const isMobile = () =>
	/iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export const orderWorkshift = (workshiftA, workshiftB) => {
	if (workshiftA === 'anytime') {
		return 1;
	}
	const shiftListA = workshiftA.value.split('-');
	const shiftStartsA = shiftListA[0];
	const militaryShiftTimeA = parseInt(moment(shiftStartsA, 'ha').format('HH'));
	const shiftListB = workshiftB.value.split('-');
	const shiftStartsB = shiftListB[0];
	const militaryShiftTimeB = parseInt(moment(shiftStartsB, 'ha').format('HH'));
	return militaryShiftTimeA > militaryShiftTimeB ? 1 : -1;
};

export const getValueFromOptions = (value, options) => {
	const option = options.find(option => {
		return option.value === value;
	});
	return option ? option.text : 'N/A';
};

export const getOptionFromValue = (value, options) => {
	const option = options.find(option => {
		return option.value === value;
	});
	return option;
};

export const groupBy = (list, keyGetter) => {
	const map = new Map();
	list.forEach(item => {
		const key = keyGetter(item);
		const collection = map.get(key);
		if (!collection) {
			map.set(key, [item]);
		} else {
			collection.push(item);
		}
	});
	return map;
};

export const formatTimeAgo = (date, { moreThanOneDay = false } = {}) => {
	const timeAgo = new TimeAgo('en-US');

	if (moreThanOneDay && moment().diff(moment(date), 'days', true) > 1) {
		return moment(date).format('lll');
	}

	return timeAgo.format(date);
};

export const convertToPNG = async imageUrl => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.crossOrigin = 'anonymous';
		img.src = imageUrl;

		img.onload = () => {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			const ctx = canvas.getContext('2d');

			ctx.drawImage(img, 0, 0);
			const pngDataUrl = canvas.toDataURL('image/png');
			resolve(pngDataUrl);
		};

		img.onerror = error => reject(error);
	});
};

export const getNumberWithOrdinal = n => {
	const s = ['th', 'st', 'nd', 'rd'];
	const v = n % 100;
	return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const isURLAbsolute = url => {
	return url.indexOf('://') > 0 || url.indexOf('//') === 0;
};

export const buildAbsoluteURL = url => {
	return `${process.env.REACT_APP_API}${url}`;
};

/** Test duration: usually minutes; values >= 1000 treated as seconds (legacy/demo). */
export const formatTestTimeTaken = value => {
	if (value == null || value === '') return '';
	const n = Number(value);
	if (Number.isNaN(n) || n < 0) return '';

	const totalMinutes = n >= 1000 ? Math.round(n / 60) : Math.round(n);
	if (totalMinutes < 60) return `${totalMinutes}'`;

	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	if (minutes === 0) return `${hours}h`;
	return `${hours}h ${minutes}m`;
};

export const formatNumberWithCommas = value => {
	if (value == null || value === '') return '';
	const raw = String(value).replace(/,/g, '').trim();
	if (raw === '' || raw === '-' || raw === '.') return raw;
	if (!/^-?\d*\.?\d*$/.test(raw)) return String(value);

	const isNegative = raw.startsWith('-');
	const unsigned = isNegative ? raw.slice(1) : raw;
	const [integerPart = '', decimalPart] = unsigned.split('.');
	const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	const sign = isNegative ? '-' : '';

	if (unsigned.includes('.')) {
		return `${sign}${formattedInteger}.${decimalPart ?? ''}`;
	}
	return `${sign}${formattedInteger}`;
};

export const parseFormattedNumber = value => {
	if (value == null || value === '') return null;
	const raw = String(value).replace(/,/g, '').trim();
	if (raw === '' || raw === '-' || raw === '.' || raw === '-.') return null;
	const n = Number(raw);
	return Number.isNaN(n) ? null : n;
};

export const formatListTitleCount = value => {
	if (value == null || value === '') return '';
	const n = Number(String(value).replace(/,/g, ''));
	if (Number.isNaN(n)) return String(value);
	if (n >= 1_000_000) {
		const m = n / 1_000_000;
		return `${parseFloat(m.toFixed(2))}M`;
	}
	if (n >= 1000) {
		const k = n / 1000;
		return `${parseFloat(k.toFixed(1))}K`;
	}
	return String(n);
};
